module.exports = __webpack_public_path__ + "static/media/caret-down-white.51f5d864.svg";